import { GET_SALE } from "../../actions/type";

export default function sales(state = {}, action) {
    switch (action.type) {
        case GET_SALE:
            return action.payload;
        default:
            return state
    }
}